<section class="filter-modal" role="dialog" aria-modal="false" aria-label="Workflow inbox filters">
  <div class="filter-modal__panel">
    <header class="filter-modal__header">
      <h3 class="filter-modal__title">filters</h3>
      <button
        type="button"
        class="filter-modal__close"
        aria-label="Close filters"
        (click)="onCloseClick()">
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
    </header>

    <div class="filter-modal__body">
      <div class="filter-modal__field filter-modal__field--full">
        <label class="filter-modal__label" for="wfSearchText">search by text</label>
        <input
          id="wfSearchText"
          class="filter-modal__input"
          type="text"
          placeholder="what are you looking for?"
          [(ngModel)]="draftSearchText" />
      </div>

      <div class="filter-modal__field filter-modal__field--full">
        <label class="filter-modal__label" for="wfAssetFilter">filter by asset</label>
        <select
          id="wfAssetFilter"
          class="filter-modal__select"
          [(ngModel)]="draftAsset">
          <option [ngValue]="null">All assets</option>
          @for (asset of assetOptions(); track asset) {
            <option [value]="asset">{{ asset }}</option>
          }
        </select>
      </div>

      <div class="filter-modal__field">
        <label class="filter-modal__label" for="wfDateFilter">filter by created date</label>
        <input
          id="wfDateFilter"
          class="filter-modal__input"
          type="date"
          [(ngModel)]="draftDate" />
      </div>

      <div class="filter-modal__field">
        <label class="filter-modal__label" for="wfRunForDateFilter">filter by run for date</label>
        <input
          id="wfRunForDateFilter"
          class="filter-modal__input"
          type="date"
          [(ngModel)]="draftRunForDate" />
      </div>

      <div class="filter-modal__field">
        <label class="filter-modal__label" for="wfTimelineFilter">filter by created timeline</label>
        <select
          id="wfTimelineFilter"
          class="filter-modal__select"
          [(ngModel)]="draftTimeline">
          <option value="all">All timelines</option>
          <option value="1w">1 week</option>
          <option value="2w">2 weeks</option>
          <option value="1m">1 month</option>
        </select>
      </div>

      @if (showCaseTypeFilter()) {
        <div class="filter-modal__field">
          <label class="filter-modal__label" for="wfExceptionTypeFilter">filter by case type</label>
          <select
            id="wfExceptionTypeFilter"
            class="filter-modal__select"
            [(ngModel)]="draftExceptionType">
            <option [ngValue]="null">All case types</option>
            @for (exceptionType of exceptionTypeOptions(); track exceptionType) {
              <option [value]="exceptionType">{{ exceptionType }}</option>
            }
          </select>
        </div>
      }

      <div class="filter-modal__field">
        <label class="filter-modal__label" for="wfWorkflowStatusFilter">filter by workflow status</label>
        <select id="wfWorkflowStatusFilter" class="filter-modal__select" [(ngModel)]="draftWorkflowStatus">
          <option [ngValue]="null">All workflow statuses</option>
          <option value="new">Open</option>
          <option value="in-progress">In progress</option>
          <option value="done">Closed</option>
        </select>
      </div>

      <div class="filter-modal__field">
        <label class="filter-modal__label" for="wfPriorityFilter">filter by priority</label>
        <select
          id="wfPriorityFilter"
          class="filter-modal__select"
          [(ngModel)]="draftPriority">
          <option [ngValue]="null">All priorities</option>
          @for (priority of priorityOptions(); track priority) {
            <option [value]="priority">{{ priority }}</option>
          }
        </select>
      </div>
      <div class="filter-modal__field filter-modal__field--full">
        <label class="filter-modal__checkbox" for="wfMyPendingActionsFilter">
          <input id="wfMyPendingActionsFilter" type="checkbox" [(ngModel)]="draftMyPendingActions" />
          <span>only cases (in-progress) assigned to me</span>
        </label>
      </div>
    </div>

    <footer class="filter-modal__actions">
      <button
        type="button"
        class="filter-modal__btn filter-modal__btn--ghost"
        (click)="onCancelClick()">
        cancel
      </button>
      <button
        type="button"
        class="filter-modal__btn filter-modal__btn--primary"
        (click)="onApplyClick()">
        apply
      </button>
    </footer>
  </div>
</section>
